<template>
  <crud-form
    v-model="payload"
    :page-title="$t('app.parameters.overdue.title')"
    :request-class="requestClass"
    :total-group="1"
    navigate-back-route="Parameters"
    navigate-page-after-save="OverdueBilletParameters"
  >
    <template slot="group-1">
      <v-flex>
        <table
          class="v-datatable v-table theme--light parameter-table"
        >
          <thead>
            <tr>
              <th
                class="column text-xs-left"
              >
                <span>{{ $t('app.parameters.headers.parameters') }}</span>
                <span
                  data-v-02776ea6
                  class="v-tooltip v-tooltip--bottom"
                />
              </th>
              <th
                role="columnheader"
                scope="col"
                class="column text-xs-left"
              >
                <span>{{ $t('app.parameters.headers.value') }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                width="30%"
                style="height: 103px"
                class="text-body-small-regular"
              >
                {{ $t('app.parameters.overdue.parameters.time') }}
              </td>
              <td>
                <v-layout
                  align="center"
                  justify="end"
                  wrap
                >
                  <v-flex
                    xs12
                    md2
                  >
                    <input-text
                      id="horarioInicial"
                      v-model="payload.horarioInicial"
                      required
                      :mask="timeMask"
                      :label="$t('app.parameters.overdue.inputs.initialHour')"
                      style="width: 136px"
                      :rules="[minTimeValue(minTime),
                               minLength(5),
                               isValidValue()]"
                      return-masked-value
                      :loading="loading"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    md1
                    class="d-flex align-center justify-center"
                  >
                    {{ $t('app.parameters.overdue.parameters.to') }}
                  </v-flex>
                  <v-flex
                    xs12
                    md2
                  >
                    <input-text
                      id="horarioFinal"
                      v-model="payload.horarioFinal"
                      required
                      :mask="timeMask"
                      :label="$t('app.parameters.overdue.inputs.finalHour')"
                      style="width: 136px"
                      :rules="[maxTimeValue(maxTime, false),
                               minTimeValue(minFinalTime),
                               isValidValue(),
                               minLength(5)]"
                      return-masked-value
                      :loading="loading"
                    />
                  </v-flex>
                </v-layout>
              </td>
            </tr>
            <tr>
              <td
                width="30%"
                style="height: 103px"
                class="text-body-small-regular"
              >
                {{ $t('app.parameters.overdue.parameters.days') }}
              </td>
              <td>
                <input-text
                  id="dias"
                  v-model="payload.dias"
                  required
                  :mask="'##'"
                  :label="$t('app.parameters.overdue.inputs.days')"
                  style="width: 136px"
                  :rules="[maxValue(30)]"
                  :loading="loading"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </v-flex>
    </template>
  </crud-form>
</template>

<script>
import InputText from 'Support/components/inputs/InputText.vue';
import OverdueBilletParametersRequest from 'Domain/parameters/OverdueBilletParametersRequest';
import CrudForm from 'Support/components/crud/CrudForm.vue';
import RulesMixin from 'Support/mixins/rules-mixin';
import Moment from 'moment';

export default {
  name: 'OverdueBilletParametersForm',
  components: {
    CrudForm,
    InputText,
  },
  mixins: [RulesMixin],
  data: () => ({
    minTime: '08:00',
    maxTime: '17:00',
    timeMask: '##:##',
    requestClass: OverdueBilletParametersRequest,
    payload: {
      horarioInicial: '',
      horarioFinal: '',
      dias: '',
    },
    headers: [
      { text: 'app.parameters.score.list.headers.parameters', sortable: false },
      { text: 'app.parameters.score.list.headers.value', sortable: false },
    ],
    loading: false,
  }),
  computed: {
    minFinalTime() {
      return Moment(this.payload.horarioInicial || this.minTime, 'HH:mm').add(1, 'minutes').format('HH:mm');
    },
  },
  created() {
    this.loading = true;
    OverdueBilletParametersRequest.get()
      .then(({ data }) => {
        this.payload = data;
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>
<style lang="stylus" scoped>
  .parameter-table
    .text-body-small-regular
      font-style normal
      font-weight normal
      font-size 14px
      line-height 99px
      color #424242
</style>
